import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { individualRestrictionGuard } from '../../guards/individual-restriction.guard';

export const admin: Routes = [
  {
    path: 'changelog',
    loadComponent: () => import('./changelog.component').then((m) => m.ChangelogComponent),
    canActivate: [individualRestrictionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class changelogRoutingModule {
  static routes = admin;
}

